import { api } from './api';
import { League } from '../types';

export interface LeaguesResponse {
    success: boolean;
    leagues: League[];
}

export interface LeagueResponse {
    success: boolean;
    league: League;
}

export interface LeagueSeason {
    season_year: number;
    label: string | null;
    preseason_date: string | null;
    is_current: boolean;
    /** True when synced matchup results exist for this year. */
    has_games?: boolean;
}

export interface SeasonsResponse {
    success: boolean;
    league_id: string;
    seasons: LeagueSeason[];
}

export const leagueService = {
    getAllLeagues: async (): Promise<LeaguesResponse> => {
        const response = await api.get<LeaguesResponse>('/leagues');
        if (response.success && response.data) {
            return response.data as LeaguesResponse;
        }
        throw new Error(response.error || 'Failed to fetch leagues');
    },

    getLeague: async (leagueId: string): Promise<LeagueResponse> => {
        const response = await api.get<LeagueResponse>(`/leagues/${leagueId}`);
        if (response.success && response.data) {
            return response.data as LeagueResponse;
        }
        throw new Error(response.error || 'Failed to fetch league');
    },

    getSeasons: async (leagueId: string): Promise<LeagueSeason[]> => {
        const response = await api.get<SeasonsResponse>(`/leagues/${leagueId}/seasons`);
        if (response.success && response.data) {
            return response.data.seasons || [];
        }
        return [];
    },
};

